import { Size } from '@ps/web-core-enums';
import { generatePath } from '@ps/web-core-utils';
import { Translation, useScreenSize } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import WebpWithFallback from '@swf/components/WebpWithFallback/WebpWithFallback';
import { select } from '@swf/core/store';

import topTearPNG from '../assets/top-tear.png';
import topTear from '../assets/top-tear.webp';

import {
  TXTWCL_Add_friends_and_play,
  TXTWCL_Create_the_Game_YOU_WANT_using_ELL,
  TXTWCL_Create_your_game,
  TXTWCL_Login_or_Create_XXAccountBrand_ELL,
  TXTWCL_Login_or_sign_up,
  TXTWCL_Share_your_game_link_with_frie_ELL
} from './Steps.messages.json';
import styles from './Steps.scss';

const STEPS = [
  {
    id: 0,
    title: <Translation {...TXTWCL_Login_or_sign_up} />,
    text: <Translation {...TXTWCL_Login_or_Create_XXAccountBrand_ELL} />
  },
  {
    id: 1,
    title: <Translation {...TXTWCL_Create_your_game} />,
    text: <Translation {...TXTWCL_Create_the_Game_YOU_WANT_using_ELL} />
  },
  {
    id: 2,
    title: <Translation {...TXTWCL_Add_friends_and_play} />,
    text: <Translation {...TXTWCL_Share_your_game_link_with_frie_ELL} />
  }
];

const STEPS_PROMO = [
  STEPS[0],
  {
    id: 1,
    title: 'JOIN THE CREATORS POKER CLUB',
    text: 'The exclusive Home Games club for fans of Pitch Side and The Club'
  },
  {
    id: 2,
    title: 'PLAY TO WIN ADDED VALUE PRIZES',
    text: 'Bet, raise and bluff your way to special added value prizes'
  }
];

export const Steps: React.FC = () => {
  const { homeGamesPromotion = '' } = useSelector(select.cms.getAliases);
  const { greaterThan } = useScreenSize();
  const location = useLocation();

  const isMobileDevice = !greaterThan(Size.Medium);
  const promoBasePath = generatePath(homeGamesPromotion, {});
  const isPromo = location.pathname.includes(promoBasePath);
  const stepsContent = isPromo ? STEPS_PROMO : STEPS;

  return (
    <>
      {isMobileDevice && (
        <WebpWithFallback
          src={topTear}
          srcFallback={topTearPNG}
          containerClassName={styles.tear}
          imageSize={{ height: 1280, width: 97 }}
        />
      )}
      <section className={styles.steps}>
        <div className={styles.inner}>
          {stepsContent.map(({ id, title, text }, index) => (
            <div key={id} className={styles.step}>
              <div className={styles.left}>{index + 1}</div>
              <div className={styles.right}>
                <div className={styles.title}>{title}</div>
                <div className={styles.text}>{text}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
